import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useAuth } from "../hooks/useAuth";
import "../styles/Cart.css";

export default function Cart() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authenticated } = useAuth();

  const {
    items,
    removeFromCart,
    updateQuantity,
    clearCart,
    totalPrice,
  } = useCart();

  const goToCheckout = () => {
    if (!authenticated) {
      navigate("/login?redirect=/checkout");
      return;
    }

    navigate("/checkout");
  };

  return (
    <main className="cart-page">
      <section className="cart-container">
        <h1>{t("cart.title")}</h1>

        {items.length === 0 ? (
          <div className="cart-empty">
            <p>{t("cart.empty")}</p>
            <button onClick={() => navigate("/shop")}>
              {t("cart.continueShopping")}
            </button>
          </div>
        ) : (
          <div className="cart-layout">
            <div className="cart-items">
              {items.map((item) => (
                <article className="cart-item" key={item.id}>
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      onClick={() => navigate(`/shop/${item.slug}`)}
                    />
                  )}

                  <div className="cart-item-info">
                    <h2 onClick={() => navigate(`/shop/${item.slug}`)}>
                      {item.name}
                    </h2>

                    <p>
                      {Number(item.price).toFixed(2)} €
                    </p>

                    <div className="cart-quantity">
                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity - 1)
                        }
                      >
                        -
                      </button>

                      <span>{item.quantity}</span>

                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="cart-item-total">
                    <strong>
                      {(Number(item.price) * item.quantity).toFixed(2)} €
                    </strong>

                    <button
                      className="cart-remove-btn"
                      onClick={() => removeFromCart(item.id)}
                    >
                      {t("cart.remove")}
                    </button>
                  </div>
                </article>
              ))}
            </div>

            <aside className="cart-summary">
              <h2>{t("cart.summary")}</h2>

              <div className="cart-summary-row">
                <span>{t("cart.subtotal")}</span>
                <strong>{totalPrice.toFixed(2)} €</strong>
              </div>

              <p className="cart-summary-note">
                {t("cart.shippingNote")}
              </p>

              <button onClick={goToCheckout}>
                {t("cart.checkout")}
              </button>

              <button className="cart-clear-btn" onClick={clearCart}>
                {t("cart.clear")}
              </button>
            </aside>
          </div>
        )}
      </section>
    </main>
  );
}